<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-laboratory-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-laboratory-create>

<pg-laboratory-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-laboratory-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
